import { State } from '../types';

import {
  AUTH_ACTION_TYPES,
  UpdateStatusAction,
  UpdateAppStateAction,
  LoadingAction,
} from './actions';
import initialState from './initialState';

export default function (
  state: State | undefined = initialState,
  action: UpdateStatusAction | UpdateAppStateAction | LoadingAction
): State {
  switch (action.type) {
    case AUTH_ACTION_TYPES.UPDATE_STATUS: {
      if (!action.isLoggedIn) {
        return {
          ...state,
          isLoggedIn: false,
          givenName: undefined,
          familyName: undefined,
          email: undefined,
          emailIsLocked: undefined,
          auth0UserId: undefined,
          'https://wetransfer.com/provider': undefined,
        };
      }

      return {
        ...state,
        isLoggedIn: true,
        givenName: action.givenName,
        familyName: action.familyName,
        email: action.email,
        emailIsLocked: action.emailIsLocked,
        picture: action.picture,
        auth0UserId: action.auth0UserId,
        'https://wetransfer.com/provider': action.loginProvider,
      };
    }

    case AUTH_ACTION_TYPES.UPDATE_APP_STATE: {
      return {
        ...state,
        state: action.state,
      };
    }

    case AUTH_ACTION_TYPES.LOADING: {
      if (state.isLoading && action.isLoading === false) {
        // From this action we can tell that the loading is done, and the first
        // time this happens we flag the auth0 as initialized
        return {
          ...state,
          isInitialized: true,
          isLoading: action.isLoading,
        };
      }

      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    default:
      return state;
  }
}
